import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { countries } from '../../static/countries';

export const FIAT_TO_ISO2: { [key: string]: string } = {
  AUD: 'au',
  CAD: 'ca',
  CHF: 'ch',
  NZD: 'nz',
  JPY: 'jp',
  USD: 'us',
  EUR: 'e_u',
  GBP: 'gb',
  CNH: 'cn',
  RUB: 'ru',
  SEK: 'se',
  HKD: 'hk',
  PLN: 'pl',
  SGD: 'sg',
  HUF: 'hu',
  NOK: 'no',
  TRY: 'tr',
  CZK: 'cz',
  DKK: 'dk',
  ZAR: 'za',
  UAH: 'ua',
  MXN: 'mx',
  ILS: 'il',
  RON: 'ro',
};

@Component({
  selector: 'app-flag',
  template: `
    <span class="icon" [ngStyle]="{ 'background-image': flagUrl }"></span>
  `,
  styleUrls: ['flag.component.scss'],
  imports: [NgStyle],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagComponent {
  flagUrl = 'url()';

  @Input()
  /** Country iso2 code or currency code */
  set code(c: string | null | undefined) {
    this.flagUrl = `url(${getCurrencyIconPath(c)})`;
  }
}

export function getCurrencyIconPath(code: string | null | undefined) {
  if (!code) {
    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAJUlEQVQYV2NkYGBg+M8w/M/AwPCfkJGR4T8GhgYGhgEAGrsD/wdNSZ8AAAAASUVORK5CYII=';
  }
  if(code === 'glob') {
    return `assets/flags/glob.svg`;
  }
  let folder = 'flags';
  let name = code;
  if (FIAT_TO_ISO2[code]) {
    name = FIAT_TO_ISO2[code];
  } else {
    const country = countries.filter(country => country.code_iso2 === code.toUpperCase())[0];
    if (!country && code !== 'e_u') {
      folder = 'currency';
    }
  }
  return `assets/${folder}/${name.toLowerCase()}.svg`;
}
